import wx from 'weixin-js-sdk'
/**
 *微信接口的promise版本
 *
 * @param {*} api
 * @param {*} options
 * @returns
 */
function promisifyWxSdk(api, options) {
    return new Promise((resolve, reject) => {
        const fn = wx[api]
        if (!fn) {
            reject(Error('方法不存在'))
        } else {
            fn({
                ...options,
                success: res => {
                    resolve(res)
                },
                fail: error => {
                    reject(Error(error.errMsg))
                }
            })
        }
    })
}

//proxy
function proxyApi(module, target, data, freeLogin = 0) {
    return new Promise((resolve, reject) => {
        window.cw(
            'ajax',
            'proxy',
            data => {
                if (data.result && data.result.error) {
                    reject(data.result.error)
                } else {
                    resolve(data.result)
                }
            },
            reject,
            {
                module,
                target,
                data,
                freeLogin
            }
        )
    })
}
// 分享二维码,生成二维码扫码后弹出外链
function getShareQrcode({
    v = Date.now(),
    uaid = window.env.VUE_APP_SITE_ID,
    desc = '点击查看详情', //外链描述
    path = window.location.href, //外链链接
    c_source = '', //分享人openid
    title = document.title,
    image = window.env.VUE_APP_LOGO
} = {}) {
    return new Promise((resolve, reject) => {
        window.cw(
            'shareQr',
            qrcode => {
                resolve(`data:image/png;base64,${qrcode}`)
            },
            reject,
            {
                v,
                uaid,
                desc,
                path,
                c_source,
                title,
                image
            }
        )
    })
}
export { promisifyWxSdk, proxyApi, getShareQrcode }
